import api, { TipoOptions } from './api';
import { OptionProps } from '@digital/ui';

export const getAllPacoteTipo = () => api.get<any[]>('status/getAllTipoPacoteTipo');

export const getAllPacoteDisciplina = () => api.get<any[]>('status/getAllTipoPacoteDisciplina');




export const getAllPacoteTipoOptions = () => {
  return getAllPacoteTipo().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
  );
}

export const getAllPacoteDisciplinaOptions = () => {
  return getAllPacoteDisciplina().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
  );
}



